/**
 * @author Jafar Amini in March 2018.
 */
import {Toolkit2} from '@angular-boot/util';
import {ActionMode} from '@angular-boot/util';

export abstract class BaseComponentThree {
  Toolkit2 = Toolkit2;
  ActionMode = ActionMode;
}
